export enum RequestStatus {
    Success = "SUCCESS",
    Failure = "FAILURE",
    Pending = "PENDING",
    Initial = "INITIAL"
}
